import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PriceBreakdown, PriceIconPortal } from "screens/Order/shared";
import { useBreakdownItemsFromOverview } from "../MusicDistribution/PriceBreakdown";

const MusicDistributionPriceBreakdown = () => {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      { id: 'reference-mastering', label: t('reference-mastering') },
      { id: 'reference-mastering-custom-reference', label: t('reference-mastering-custom-reference') }
    ],
    []
  );

  const breakdownItems = useBreakdownItemsFromOverview(items);

  return <PriceBreakdown items={breakdownItems} />;
};

export const MasteringPriceCloudPortal = () => {
  return (
    <>
      <PriceIconPortal>
        <MusicDistributionPriceBreakdown />
      </PriceIconPortal>
    </>
  );
};
